import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Card from 'react-bootstrap/Card';
import AppCard from 'components/Card/Card';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import { parseStringField, checkGroupFields } from "helpers/FieldHelper";
import { getImgUrl } from "helpers/ImageHelper";
import { pubPath } from 'helpers/AppHelper';
import './ClipItem.scss';

const ClipItem = observer(
    class ClipItem extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        onClipItem = () => {
            const { viewMode } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: this.props.clip,
                viewMode: ConfigTypes.DETAIL,
                toTop: true,
                lastView: viewMode
            });
            this.props.router.navigate(`${ConfigTypes.CLIP_PATH}/${this.props.clip.id}`);
        }

        showPortraitCard = (viewMode) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.clip });
            const showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.OBJECT });
            return (
                <Card className="clipitem-card">
                    <Card.Img variant="top" src={imgUrl} onClick={this.onClipItem} className="clipitem-card-img" />
                    <Card.Body>
                        {showFields.map((el, i) => {
                            return (
                                <div key={`clipItemGridItem${i}`}
                                    className={el[`${viewMode}html`] ? 'clipitem-card-title' : 'clipitem-card-text'}>
                                    {parseStringField(this.props.clip.metadata.fields[el.field])}
                                    {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.clip, viewMode })}
                                </div>)

                        })}
                    </Card.Body>
                </Card>)
        }

        showGridItem = (viewMode) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.clip });
            const showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.OBJECT });
            return this.showPortraitCard(viewMode);
        }

        showClipItem = () => {
            const { viewMode } = this.props.mediaObjects;
            if (viewMode == ConfigTypes.GRID) {
                return this.showGridItem(viewMode);
            } else if (viewMode == ConfigTypes.LIST) {
                const showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.OBJECT });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.clip });
                return (
                    <li className="list-group-item clipitem-list-item" onClick={this.onClipItem}>
                        {showFields.map((el, i) => {
                            if (i == 0) return (<img key={`clipItemListItem${i}`} className="img-responsive img-rounded clipitem-img" src={imgUrl} alt="" />)
                            return (
                                <div key={`clipItemListItem${i}`}
                                    className={el[`${viewMode}html`] ? 'clipitem-card-title' : 'clipitem-card-text'}>
                                    {/* {this.props.clip.metadata.fields[el.field] || ''} */}
                                    {parseStringField(this.props.clip.metadata.fields[el.field])}
                                    {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.clip, viewMode })}
                                </div>)
                        })}
                    </li>)
            }
        }

        getItemClasses = (el) => {
            const { viewMode } = this.props.mediaObjects;
            let classes = "clipitem-card-text";
            if (el[`${viewMode}html`]) classes = 'clipitem-card-title';
            if (viewMode == ConfigTypes.LIST) {
                classes = 'clipitem-card-title-list clipitem-card-item-list';
            }
            return classes;
        }

        showPortalSearchClipItem = () => {
            const { viewMode } = this.props.mediaObjects;
            let htmlClasses = "clipitem-card-conten-grid";
            if (viewMode == ConfigTypes.GRID) {
                return this.showGridItem(viewMode);
            } else if (viewMode == ConfigTypes.LIST) {
                const showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.OBJECT });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.clip });
                htmlClasses = "clipitem-card-content-list";
                return (
                    <li className="list-group-item clipitem-list-item" onClick={this.onClipItem}>
                        <div className="clipitem-card-content-list">
                            {/* <img className="img-responsive img-rounded clipitem-img" src={imgUrl} alt="" /> */}
                            {showFields.map((el, i) => {
                                let dategroup = false;
                                if (el[`${viewMode}type`] && (el[`${viewMode}type`] == ConfigTypes.DATEGROUP)) dategroup = true;
                                if (i == 0) return (
                                    <div className="clipitem-card-imgbox" key={`clipItemListItem${i}`}>
                                        <img className="img-responsive img-rounded clipitem-img" src={imgUrl} alt="" />
                                    </div>
                                )
                                return (
                                    <div key={`clipItemListItem${i}`} className={this.getItemClasses(el)}>
                                        {!dategroup && parseStringField(this.props.clip.metadata.fields[el.field])}
                                        {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.clip, viewMode })}
                                    </div>)
                            })}
                        </div>
                    </li>)
            }
        }

        render() {
            return this.showPortalSearchClipItem();
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(ClipItem)));